import api from '@pray/shared/utils/api';

export async function getPrayRadioAudioContent({
  artistId,
  filterArtistId,
  search = '',
  offset = 0,
  limit = 50,
}: {
  artistId: string;
  filterArtistId?: string;
  search?: string;
  offset?: number;
  limit?: number;
}) {
  if (!artistId) throw Error('Artist ID is required');

  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (offset) params.set('offset', String(offset));
  if (limit) params.set('limit', String(limit));
  if (filterArtistId) params.set('artist_id', filterArtistId);

  const url = `/web/studio/artists/${artistId}/pray-radio-audio-content`;
  const queryString = params.toString();
  const response = await api.executeGetRequest(queryString ? `${url}?${queryString}` : url);

  return response.data;
}
